module.exports = __webpack_public_path__ + "static/media/review_good.167e2ce8.png";